'use client'
import { useEffect } from 'react'

import { useSession, signOut } from 'next-auth/react'

export default function BamaAuthWatcher() {
  const { data: session, status } = useSession()

  useEffect(() => {
    if (status === 'authenticated' && session?.error === 'RefreshAccessTokenError') {
      signOut({ callbackUrl: '/login' }).then(r => console.info(r))
    }
  }, [status, session])

  return null
}

// TODO-QA/PROD: este flujo se mantiene igual en prod (logout automático si falla refresh).
